import { render, staticRenderFns } from "./OurAgency.vue?vue&type=template&id=2a5ad2c2&lang=html&"
import script from "./OurAgency.vue?vue&type=script&lang=js&"
export * from "./OurAgency.vue?vue&type=script&lang=js&"
import style0 from "./OurAgency.vue?vue&type=style&index=0&id=2a5ad2c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports